import React, { useEffect, useRef } from "react";
import "../../Survey/SurveyVars.css";
import "./ParticipantConfirm.css";
import LocalizedText from '../../presentational/LocalizedText';

interface ParticipantConfirmDialogProps {
    message: string;
    okTextKey?: string;
    cancelTextKey?: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export default function ParticipantConfirmDialog(props: ParticipantConfirmDialogProps) {
    const okTextKey = props.okTextKey ?? "global-ok-button-text";
    const cancelTextKey = props.cancelTextKey ?? "global-cancel-button-text";
    const dialogRef = useRef<HTMLDialogElement>(null);

    useEffect(() => {
        dialogRef.current?.showModal();
    }, []);

    return (
        <dialog className="participant-confirm-dialog" ref={dialogRef} onCancel={props.onCancel}>
            <p className="participant-confirm-message">{props.message}</p>
            <div className="participant-confirm-buttons">
                <button className="continue-button participant-confirm-cancel" onClick={props.onCancel}><LocalizedText textKey={cancelTextKey} /></button>
                <button className="continue-button" onClick={props.onConfirm}><LocalizedText textKey={okTextKey} /></button>
            </div>
        </dialog>
    );
}
